import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'maintance-reason',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `maintance-reason`,
    method: 'get',
    params: queriesParams
  })
}

export function addMaintanceReason (maintanceReason) {
  return request({
    method: 'post',
    url: 'maintance-reason',
    data: maintanceReason
  })
}

export function show (id) {
  return request({
    url: `maintance-reason/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `maintance-reason/${id}`,
    method: 'patch',
    data
  })
}
